module.exports = __webpack_public_path__ + "static/media/onboarding1.e802104b.jpg";